var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09428 3.64168C6.84019 3.1335 6.32079 2.8125 5.75264 2.8125H4.3125C3.48407 2.8125 2.8125 3.48407 2.8125 4.3125V4.35938C2.8125 10.3396 7.66042 15.1875 13.6406 15.1875H13.6875C14.5159 15.1875 15.1875 14.5159 15.1875 13.6875V12.2474C15.1875 11.6792 14.8665 11.1598 14.3583 10.9057L12.8601 10.1566C12.4025 9.92779 11.8497 10.0175 11.4879 10.3793C11.1516 10.7156 10.6431 10.8267 10.2188 10.612C8.93109 9.96019 8.03981 9.06891 7.38802 7.78119C7.17326 7.3569 7.28443 6.84838 7.62069 6.51212C7.98251 6.1503 8.07221 5.59755 7.84338 5.13988L7.09428 3.64168Z",
    stroke: "#FF7926",
    strokeWidth: 1.13,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b9f36a3be39401b3f11745bc6717d1f4.svg";
export { ForwardRef as ReactComponent };